import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { name: "O&M Digital", tagline: "O&M Digital Management", address: "", email: "", phone: "", gst: "", website: "", logo_url: "" };

const BrandingContext = createContext(DEFAULTS);
export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/branding")
      .then((r) => setBranding({ ...DEFAULTS, ...(r.data || {}) }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const n = branding.name || "O&M Digital";
    document.title = n === "O&M Digital" ? "O&M Digital" : `${n} | O&M Digital`;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", `${n} — O&M Digital Management Platform`);
  }, [branding.name]);

  useEffect(() => {
    if (!branding.logo_url) return;
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.logo_url;
  }, [branding.logo_url]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}
